import React from "react";
const AutoPayNotEligibleCallUs = (props) => {
  return (
    <div>
        <div className="f14 mb-3">
          Please give us a call at 888.267.7200 to edit or cancel your AutoPay on this loan.
        </div>
      <button
        className="autopay-button-new d-flex m-auto"
        style={{ color: "white" }}
        onClick={() => {
          props.closeModal();
        }}
      >
        <span>Close</span>
      </button>
    </div>
  );
};

export default AutoPayNotEligibleCallUs;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/modal/autopay-not-eligible-call-us.js